import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

import { TEMPLATES, TEMPLATES_ENG } from 'entities/application/constants';
import { ApplicationLogoContainer } from 'entities/application/ui/ApplicationLogoContainer/ApplicationLogoContainer';
import { TemplateDetails } from 'entities/application/ui/TemplateDetails/TemplateDetails';
import { TemplateHeader } from 'entities/application/ui/TemplateHeader/TemplateHeader';
import {
	ApplicationContentStyled,
	ApplicationMainStyled,
	ApplicationSideStyled,
} from 'pages/application/ui/Application/Application.styles';
import { useScrollToTop } from 'shared/lib/useScrollToTop';
import { BackButton } from 'shared/ui/BackButton/BackButton';
import { TemplatePageStyled } from './TemplatePage.styles';

interface Props {
	templateId: string;
}

export const TemplatePage: FC<Props> = ({ templateId }) => {
	useScrollToTop();
	const { t, i18n } = useTranslation();
	const template =
		i18n.language === `ru-RU`
			? TEMPLATES.find(n => n.id === templateId)
			: TEMPLATES_ENG.find(n => n.id === templateId);

	if (!template) {
		return null;
	}

	const {
		name,
		logoBgr,
		logoUrl,
		description,
		categories,
		countries,
		conceptions,
		webSiteUrl,
		developer,
		descriptionHTML,
		redirectUrl,
	} = template;

	return (
		<TemplatePageStyled>
			<BackButton />
			<ApplicationContentStyled>
				<ApplicationSideStyled>
					<ApplicationLogoContainer
						logoBgr={logoBgr}
						logoUrl={logoUrl}
						name={name}
						applicationId={templateId}
					/>
					<a href={redirectUrl} rel='noreferrer' target='_blank'>
						<Button type='primary' block size='large'>
							{t(`Marketplace_Download_Module`)}!
						</Button>
					</a>
					<TemplateDetails
						categories={categories}
						conceptions={conceptions}
						countries={countries}
						developer={developer}
						websiteUrl={webSiteUrl}
					/>
				</ApplicationSideStyled>
				<ApplicationMainStyled>
					<TemplateHeader name={name} description={description} />
					{descriptionHTML ? descriptionHTML({}) : null}
				</ApplicationMainStyled>
			</ApplicationContentStyled>
		</TemplatePageStyled>
	);
};
